import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
//mui
import { Dialog, DialogContent, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
//slice
import { handleCloseVideoModal } from '../../../../../store/slices/reportsSlice';
import VideoPlayer from '../../ReportDetails/components/VideoPlayer';


const VideoPlayerModal = ({ videoSrc, videoHighlights=[], startTime=null }) => {
    const dispatch = useDispatch();
    const { videoPlayerModal } = useSelector((state) => state.reports);
    const isMobile = useSelector((state) => state.config?.isMobile);
    

    return (
        <Dialog
            open={videoPlayerModal}
            onClose={() => dispatch(handleCloseVideoModal())}
            // disableScrollLock
            fullScreen
            slotProps={{
                container: {
                    sx: {
                        height: 'auto', // Set this to 'auto' or any specific value you prefer
                    },
                },
            }}
            PaperProps={{
                sx: {
                    width: 'fit-content',
                    maxWidth: isMobile ? '100vw' : '1000px',
                    height: isMobile ? '100vh' : '95vh',
                    maxHeight: '800px',
                    borderRadius: '10px',
                    overflow: 'hidden',
                    backgroundColor: 'rgba(255, 255, 255)',
                    boxShadow: 24,
                    position: 'relative',
                },
            }}
        >
            <IconButton
                onClick={() => dispatch(handleCloseVideoModal())}
                sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    zIndex: 2,
                    color: 'black',
                }}
            >
                <CloseIcon />
            </IconButton>
            
            <DialogContent
                sx={{
                    padding: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'transparent',
                    height: '100%',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flex: 1,
                        alignItems: 'center',
                        justifyContent: 'center',
                        position: 'relative',
                        paddingTop: '30px',
                        width: '100%',
                        height: '100%',
                    }}
                >
                    <VideoPlayer
                        videoSrc={videoSrc}
                        fullSize={true}
                        videoHighlights={videoHighlights}
                        startTime={startTime}
                    />
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default VideoPlayerModal;